/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Custompagetemplates2Inputs */

const en_entity_custompagetemplates2 = /** @type {(inputs: Entity_Custompagetemplates2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Page Templates`)
};

const de_entity_custompagetemplates2 = /** @type {(inputs: Entity_Custompagetemplates2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlagen`)
};

/**
* | output |
* | --- |
* | "Custom Page Templates" |
*
* @param {Entity_Custompagetemplates2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_custompagetemplates2 = /** @type {((inputs?: Entity_Custompagetemplates2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Custompagetemplates2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_custompagetemplates2(inputs)
	return de_entity_custompagetemplates2(inputs)
});
export { entity_custompagetemplates2 as "entity_customPageTemplates" }